<section class="content">
    <div class="container mt-3">
        <div class="row">
            <div class="col-md-5">
                <label class="form-label" for="selectedProject">Project(s)</label>
                <mat-select multiple data-mdb-select-init multiple id="selectedProject" name="selectedProject" class="form-control" [(ngModel)]="selectedProjects">
                    <option selected="selected" disabled="disabled" [ngValue]="null">--Select the Project--</option>
                    <ng-container *ngFor="let project of projects">
                        <mat-option [value]="project.id">{{project.name}}</mat-option>
                    </ng-container>
                </mat-select>
            </div>
            <div class="col">
                <button *ngIf="!running" type="button" class="btn btn-primary" style="margin-top: 30px;" [class.disabled]="!selectedProjects || selectedProjects.length==0" [disabled]="!selectedProjects || selectedProjects.length==0" (click)="run()">Get Results</button>
                <button *ngIf="running" type="button" class="btn btn-primary disabled" style="margin-top: 30px;" disabled="disabled">Retrieving...</button>
            </div>
        </div>
    </div>
    <div class="row text-end">
        <div class="col">
            <button type="button" class="btn btn-success" [class.disabled]="!users || users.length==0" [disabled]="!users || users.length==0" (click)="export()">Export Results</button>
        </div>
    </div>
    <div class="row mt-3">
        <ag-grid-angular
            class="ag-theme-alpine"
            [rowData]="users"
            [domLayout]="'autoHeight'"
            [animateRows]="true"
            [pagination]="true"
            [columnDefs]="colDefs"
            [gridOptions]="userGridOptions"
            (gridReady)="onGridReady($event)"
        >
        </ag-grid-angular>
    </div>
</section>
